export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const SUPP_SUCCESS = "SUPP_SUCCESS";
export const NEWONNETMEDS_SUCCESS = "NEWONNETMEDS_SUCCESS";
export const COVIDESSENTIALS_SUCCESS = "COVIDESSENTIALS_SUCCESS";
export const BESTSELLER_SUCCESS = "BESTSELLER_SUCCESS";

export const FETCHFILTERDATA = "FETCHFILTERDATA";
export const CART_SUCCESS = "CART_SUCCESS";
